/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The OrderUpdateOrderStatusParam model module.
 * @module model/OrderUpdateOrderStatusParam
 * @version 1.0
 */
class OrderUpdateOrderStatusParam {
    /**
     * Constructs a new <code>OrderUpdateOrderStatusParam</code>.
     * @alias module:model/OrderUpdateOrderStatusParam
     */
    constructor() { 
        
        OrderUpdateOrderStatusParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrderUpdateOrderStatusParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrderUpdateOrderStatusParam} obj Optional instance to populate.
     * @return {module:model/OrderUpdateOrderStatusParam} The populated <code>OrderUpdateOrderStatusParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderUpdateOrderStatusParam();

            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} status
 */
OrderUpdateOrderStatusParam.prototype['status'] = undefined;






export default OrderUpdateOrderStatusParam;

